<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取终端组结构</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			get_tgroup_hierarchy接口提供了创建人员组的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/get_tgroup_hierarchy">https://skfrm.cn/APIV2/get_tgroup_hierarchy</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-Value-New :propsTableData='frmReturnValueNew'></frm-Return-Value-New>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"data":
		[
			{
				"group_id":"5389",
				"group_name":"公共人员底库",
				"total_terminal_number":"0",
				"subgroup":
				[
					{
						"group_id":"5389",
						"group_name":"公共人员底库",
						"total_terminal_number":"0",
						"subgroup":[]
					}
				]
			}
		],
	}
失败：
	{
		"error_code":"4",
		"error_msg":"服务器内部错误"
	}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
import FrmReturnValueTableNew from '../../../../components/frmReturnValueTableNew';
import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,
'frm-Return-Value-New':FrmReturnValueTableNew,
'frm-Error-Code':FrmErrorCodeTable, 

		},
		data(){
			return{
				isPathData:['FRM API-v2','终端管理','获取终端组结构'],
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
					{"require":"是","name":"project_id","type":"int","msg":"项目id"},
				],


frmReturnvalue:[
					{"Parameter":"error_code","name":"string","msg":"0 成功  1 失败"},
					{"Parameter":"error_msg","name":"string","msg":"成功返回 success  失败返回 fail"},
					{"Parameter":"data","name":"array","msg":"             "},
					],
frmReturnValueNew:[
					{
						"Parameter":"error_code",
						"name":"string",
						"msg":"0 成功  1 失败",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"error_msg",
						"name":"string",
						"msg":"成功返回 success  失败返回 fail",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"返回组信息结构",
						"rowspan":5,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"group_id    string         终端组id",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"group_name    string         终端组名称",
					},
					// {
					// 	"Parameter":"data",
					// 	"name":"array",
					// 	//"msg":"total_terminal_number    string   当前终端组终端总数",
					// },
					{
						"Parameter":"data",
						"name":"array",
						"msg":"subgroup    string         当前终端组子组信息数组",
					},
				],

frmErrorCode:[
					{"Statuscode":"1","errormessage":"fail","msg":"服务器繁忙"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Terminalmanagement/Acquisitionterminalstructure.vue